import { SidebarTrigger } from "@ui/components/ui/sidebar";
import { observer } from "mobx-react-lite";
import { cn } from "ui";

import { useBreadcrumbs } from "src/hooks/useBreadcrumbs";
import { NotificationButton } from "src/notifications/Notifications";

import { useSetContentElement } from "./AuthenticatedNavigationContext";
import { AuthMenu } from "./AuthMenu";
import { NavbarSavingIndicator } from "./NavbarSavingIndicator";

interface Props {
  className?: string;
  sidebarShown: boolean;
}

export const AuthenticatedNavigation = observer(
  function AuthenticatedNavigation(props: Props) {
    const setContentElement = useSetContentElement();
    const breadcrumbs = useBreadcrumbs();

    return (
      <nav
        className={cn(
          "sticky top-0 px-4 py-2 left-0 z-50 right-0 h-[var(--sztama-auth-toolbar-height)] flex justify-between items-center border-b border-gray-200 bg-white space-x-4",
          props.className,
        )}
      >
        <div className={"flex w-full items-center"}>
          {props.sidebarShown ? (
            <SidebarTrigger className="w-8 h-8 p-0 rounded-[0.5rem]" />
          ) : null}
          <div className="h-4 w-[1px] bg-border mr-4 ml-2"></div>
          {breadcrumbs ? (
            <div className="w-full">{breadcrumbs}</div>
          ) : (
            <div ref={setContentElement} className="w-full" />
          )}
        </div>
        <div className="flex gap-2 items-center">
          <div className="mr-8">
            <NavbarSavingIndicator />
          </div>
          <NotificationButton></NotificationButton>
          <AuthMenu />
        </div>
      </nav>
    );
  },
);
